import { Button, Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ReactComponent as OpenLinkIcon } from './../../../../assets/open_link.svg';
import { useTranslation } from 'react-i18next';

export const TagGtmContent = () => {
  const { t } = useTranslation(['cookies']);
  return (
    <>
      <Row>
        <Column
          xs={12}
          flex
          style={{
            alignItems: 'center',
            marginBlock: '16px',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
          <span style={{ fontSize: '14px', fontWeight: '400', marginInline: '12px', textWrap: 'nowrap' }}>
            {t('cookies:show.gtm.title')}
          </span>
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <Card
            sx={{
              backgroundColor: '#f9fafb',
              padding: '12px 24px',
              boxShadow: 'none',
              border: '1px solid #ccc',
            }}
          >
            <Row>
              <Column xs={11}>
                <span style={{ fontSize: '14px' }}>
                  {t('cookies:show.gtm.followLink')}&nbsp;
                  <a
                    style={{ textDecoration: 'none', color: '#1976d2' }}
                    href="https://support.vofficer.io/hc/pt-br/articles/23322149914260-Integração-do-Banner-de-Cookies-com-o-Google-Tag-Manager"
                    rel="noreferrer"
                    target="_blank"
                  >
                    {t('cookies:show.gtm.linkText')}
                  </a>
                  .
                </span>
              </Column>
              <Column xs={1} className="pr-0" style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  variant="link"
                  startIcon={<OpenLinkIcon width="22px" height="24px" style={{ padding: '2px' }} />}
                  size="small"
                  sx={{ padding: '6px', minWidth: '32px' }}
                  href="https://support.vofficer.io/hc/pt-br/articles/23322149914260-Integração-do-Banner-de-Cookies-com-o-Google-Tag-Manager"
                  rel="noreferrer"
                  target="_blank"
                ></Button>
              </Column>
            </Row>
          </Card>
        </Column>
      </Row>
    </>
  );
};
